import useSWRImmutable from 'swr/immutable';

import { WHERE } from 'src/utils/firebase/firebase-manager';
import { getUsers } from 'src/utils/firebase/firebase-short-cut';

const useSWRUsers = (where?: WHERE[]) => {
  const {
    data: users,
    error,
    isValidating: usersLoading,
    mutate,
  } = useSWRImmutable(where ? `users-${where.join('-')}` : 'users', () => getUsers(where));

  return {
    users,
    error,
    usersLoading,
    refresh: () => mutate(),
  };
};

export default useSWRUsers;
